/**
 * Выбирает ключи объекта T, значения которых могут быть string, null или undefined
 */
type StringOrNullOrUndefinedKeys<T> = {
	[K in keyof T]: T[K] extends string | null | undefined ? K : never
}[keyof T]

/**
 * Создает новый тип, где выбранные поля K становятся строками
 */
type UpdatedObject<T, K extends StringOrNullOrUndefinedKeys<T>> = {
	[P in keyof T]: P extends K ? string : T[P]
}

/**
 * Заменяет null или undefined значения на пустую строку для указанных полей объекта
 * @param obj Исходный объект
 * @param fields Массив ключей полей, которые нужно обработать
 * @returns Новый объект с замененными значениями
 */
export function replaceNullWithEmptyString<T, K extends StringOrNullOrUndefinedKeys<T>>(obj: T, fields: K[]): UpdatedObject<T, K> {
	const result = { ...obj }
	fields.forEach((field) => {
		if (result[field] === null || result[field] === undefined) {
			;(result[field] as any) = ''
		}
	})
	return result as UpdatedObject<T, K>
}

interface TestObject {
	name: string
	age: number
	email: string | null | undefined
	address?: string 
}

const testObj: TestObject = {
	name: 'John',
	age: 30,
	email: null,
	address: undefined,
}

const updatedObj = replaceNullWithEmptyString(testObj, ['email', 'address'])
const emailType = updatedObj.email
const addressType = updatedObj.address